module.exports = __webpack_public_path__ + "img/img-466a88.png";